export interface TabTimeNumberOptions {
    useGlobalAggregation: boolean;
}

const defaultTabOptions: TabTimeNumberOptions = {
    useGlobalAggregation: true,
};

export { defaultTabOptions };
